"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const units_service_1 = require("./units.service");
const configuration_1 = require("@common/configuration");
class UnitBaseFieldService extends units_service_1.UnitsService {
    constructor(token) {
        super(token);
        this.endpointBaseUrl = configuration_1.Configuration.unitsServiceConfig().apiV2;
    }
    async getUnitBaseFieldsValues(uuid, baseFields) {
        const response = await this.httpService.get(`${this.endpointBaseUrl}/unit-base-fields?filter[unit_id]=${uuid}&filter[base_field][in]=${baseFields}`, { headers: this.getHeaders() });
        return response.data.data;
    }
    async saveUnitBaseFields(unitBaseFields) {
        const headers = this.getHeaders();
        headers["System"] = "admin-ui";
        const response = await this.httpService.post(`${this.endpointBaseUrl}/unit-base-fields`, unitBaseFields, { headers: headers });
        return response.data;
    }
    async updateUnitBaseFields(id, unitBaseFields) {
        const headers = this.getHeaders();
        headers["System"] = "admin-ui";
        const response = await this.httpService.patch(`${this.endpointBaseUrl}/unit-base-fields/${id}`, unitBaseFields, { headers: headers });
        return response.data;
    }
    async processUnitBaseFields(unitBaseFields) {
        const headers = this.getHeaders();
        headers["System"] = "admin-ui";
        const response = await this.httpService.post(`${this.endpointBaseUrl}/unit-base-fields/by-unit`, unitBaseFields, { headers: headers });
        return response.data;
    }
}
exports.UnitBaseFieldService = UnitBaseFieldService;
//# sourceMappingURL=unit-base-field.service.js.map